module.exports = __webpack_public_path__ + "img/Hunter-nightelf-f-60.90be795a.gif";